export const env = process.env.REACT_APP_ENV;
export const REDIRECT_URL = `${window.location.protocol}//${
    window.location.host
}`;
export const SERVICE_URL = process.env[`REACT_APP_SERVICE_URL_${env}`];
export const CLIENT_ID = process.env[`REACT_APP_CLIENT_ID_${env}`];
export const KIBANA_URL = process.env[`REACT_APP_KIBANA_URL_${env}`];
